import {ComparisonOperator, LogicalOperator} from '../../models/Enum/FilterProperties';

export class FilterQueries {
    parameters: Filter | undefined;
}

export interface FilterClient {
    filter: Filter;
    tag?: string;
    selected: boolean;
    label: string;
}

export enum TypeFilter{
    client='client-side',
    server='server-side',
}
export interface CheckboxFilterClient extends FilterClient {
    oppositeFilter: Filter;
    asCheckbox: boolean;
}
export type FilterGroup = { set: (FilterClient | CheckboxFilterClient)[]; hidden?: boolean; selected?: boolean; includeAlle?: boolean; } & ({ operator: LogicalOperator; multiple: true; } | { multiple: false });
export abstract class Filter {
    type: string;

    constructor(type: string) {
        this.type = type;
    }
}

export class FieldFilter extends Filter {
    static readonly _type: string = 'field';

    field: string | undefined;
    operator: ComparisonOperator | undefined;
    value: any;

    static create(field: string, operator: ComparisonOperator, value: any): Filter {
        return { type: this._type, field, operator, value } as Filter;
    }
}
export class DateFilter extends FieldFilter {
    static readonly _type: string = 'date';

    value: string | undefined;
    includeTime: boolean | undefined;
    format: string  | undefined;

    static create(field: string, operator: ComparisonOperator, value: Date, includeTime?: boolean, format?: string): Filter {
        return { type: this._type, field, operator, value: value.toISOString(), includeTime: includeTime ?? false, format } as Filter;
    }
}

export class FilterCombinator {
    static create(left: Filter, type: LogicalOperator, right: Filter) {
        return ({ left, type, right }) as Filter;
    }
    static combine(value: Filter[], type: LogicalOperator): Filter {
        if (value.length === 1) return value[0];
        return value.slice(1).reduce((prev, current) => ({ type, left: prev, right: current }), { ...value[0] });
    }
}

class CombineFilter extends Filter {
    protected static readonly _type: LogicalOperator = 'Or';

    left: Filter | undefined;
    right: Filter | undefined;


    static create(left: Filter, right: Filter) { return FilterCombinator.create(left, this._type, right); }
    static combine(value: Filter[]): Filter { return FilterCombinator.combine(value, this._type); }
}
export class OrFilter extends CombineFilter {
    protected static readonly _type: LogicalOperator = 'Or';
}

export class AndFilter extends CombineFilter {
    protected static readonly _type: LogicalOperator = 'And';
}

export class NotFilter extends Filter {
    protected static readonly _type: LogicalOperator = 'Not';
    condition: Filter | undefined;

    static create(condition: Filter) { return ({type: this._type , condition }); }
}
